<template>
  <a-modal centered :width="800" :visible="openActivities" title="New time entry"  @cancel="onCancel">
    <a-form :form="form" @submit.prevent="handleSubmit">
      <div class="flex flex-col md:flex-row space-x-0 md:space-x-8">
        <div class="w-full md:w-1/2">
          <div class="flex flex-row space-y-0 space-x-4">
            <a-form-item label="Duration" has-feedback>
              <a-input
                v-decorator="['duration',{ rules: [{ required: false, message: 'Please Enter Time field.' },{ pattern: /^\d+$/,message:'You can only enter numbers', required: true }] }]"
                placeholder="recorded Time"
                autocomplete="none"
                addon-after="hour"
                class="recorded_time"
              />
            </a-form-item>
            <Timer @Timer="(timing)=>timer(timing,form,'duration')" @startTime="startTime" :time="time" ref="timer" class="timer self-center md:self-end mt-5 md:mt-0"/>
          </div>
          <SelectOption ref="user" url="/account/list/" label="User" field="user" :required="true" method="get" placeholder="Find A User" class="w-full"/>
          <a-form-item label="Headline" has-feedback>
            <a-select
              v-decorator="['category',{ rules: [{ required: true, message: 'This field is required.' }] }]"
              class="select select-expense-type"
              allowClear
              placeholder="Times category"
              option-label-prop="label"
              show-search
              :filter-option="filterOption"
              @change="selectExpenseType"
            >
              <!--                <div slot="dropdownRender" slot-scope="menu">-->
              <!--                  <v-nodes :vnodes="menu" />-->
              <!--                  <a-divider style="margin: 4px 0;" />-->
              <!--                  <div-->
              <!--                    style="padding: 8px 8px; cursor: pointer;color: #3A3DBE"-->
              <!--                    @click="addCategoryToExpense"-->
              <!--                  >-->
              <!--                    <a-icon type="plus-circle" />  Create new time category-->
              <!--                  </div>-->
              <!--                </div>-->
              <a-select-option v-for="item in time_categories" :label="item.name" :value="item.id">
                {{ item.name }} ({{'$' + item.rate }})
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Description" has-feedback>
            <a-textarea
              v-decorator="['description',{ rules: [{ required: false, message: 'Please input your username!' }] }]"
              :rows="7"
            />
          </a-form-item>
        </div>
        <div class="w-full md:w-1/2">
          <selectSearch
            :required="true"
            url="/matter/query/"
            :options="optionSearchMatter"
            field="matter"
            label="Matters"
            class="self-center mt-8 md:mt-0 w-full"
            :is_include_matter="true"
            ref="activityMatter"
          />
          <a-form-item label="Date" has-feedback>
            <a-date-picker
              v-decorator="['date',{ initialValue:new Date().toISOString().split('T')[0],rules: [{ required: true, message: 'This field is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
            />
          </a-form-item>
          <div class="flex space-x-2">
            <a-form-item label="Rate" has-feedback>
              <a-input
                v-decorator="['rate',{ initialValue: '0.00',rules: [{ required: false, message: 'Please input your username!' },{ pattern:/[+-]?([0-9]*[.])?[0-9]+/,message:'Select a valid rate.', required: false }] }]"
                placeholder="0.00"
                class="ant-input"
                autocomplete="off"
                @blur="convertToDecimal('rate',form)"
              />
            </a-form-item>
            <p class="self-center md:self-end font-semibold text-sm text-gray-400 mt-3 md:mt-0">Default rate</p>
          </div>
          <div class="flex items-center">
            <a-form-item>
              <a-checkbox
                v-decorator="['is_no_billable',{ valuePropName:'checked' }]"
              >
                non-billable
              </a-checkbox>
            </a-form-item>
            <a-icon class="self-start md:self-center mt-4 md:mt-0" type="info-circle" theme="twoTone" two-tone-color="#3A3DBE"/>
          </div>
        </div>
      </div>
      <a-divider/>
      <div class="flex space-x-2">
        <a-button type="primary" html-type="submit" style="border-radius: 3px !important;">
          Save Entry
        </a-button>
        <!--            <a-button color="primary" type="border" size="small">-->
        <!--              Save & create another-->
        <!--            </a-button>-->
        <!--            <a-button color="primary" type="border" size="small">-->
        <!--              Save List Template-->
        <!--            </a-button>-->
        <a-button type="primary" ghost @click="onCancel" style="border-radius: 3px !important;">
          Cancel
        </a-button>
      </div>

    </a-form>
  </a-modal>
</template>

<script>

import axios from '@/axios'
import mixin from '../mixin/mixin'
import SelectOption from "../forms/SelectOptionSingle"
import selectSearch from "@/views/forms/selectSearch";
import Timer from "@/layouts/components/timer/Timer";


export default {
  name: "ModalActivity",
  components:{
    SelectOption,
    selectSearch,
    Timer
  },
  props: {
    taskId: {
      type: Number,
      default: null,
      required: false
    }
  },
  mixins:[mixin],
  data(){
    return{
      openActivities: false,
      stop_time:false,
      time_categories: []
    }
  },
  methods:{
    onCancel(){
      this.openActivities = false
    },
    startTime(){
      this.stop_time = false
      // if(this.form.getFieldValue('duration'))
      //   this.$refs.timer.formattedElapsedTime = this.form.getFieldValue('duration') * 3600
    },
    selectExpenseType(value) {
      const findCategoryTime = this.time_categories.find(item => item.id === value)
      this.form.setFieldsValue({ rate: findCategoryTime !== undefined ? findCategoryTime.rate : undefined })
    },

    async getCategoryTimes(){
      try{
        const { data } = await axios.post('/activity/time-entry/category/query/',{limit:100})
        this.time_categories = data.rows
      }catch (e){
        throw e
      }
    },

    handleSubmit(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            if (this.taskId) values.task_id = this.taskId
            await axios.post(`/activity/time-entry/`, values)
            this.openActivities = false
            this.$notification['success']({
              message: 'Success',
              description: `Time Entry 'created`,
            });
            this.form.resetFields()
            await this.$router.push('/activities')
            //this.$refs.Activities.fetch().then(()=>{})
          }catch (e){
            this.$notification['error']({
              message: 'Error',
              description: `Please try again.`,
            });
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },
  },
  mounted() {
    this.getCategoryTimes()
  }
}
</script>

<style scoped>

</style>
